import type { NotificationType } from './notifications';
import type { NotificationSubscription } from './subscriptions';

/**
 * Returns the category of a notification with a given subscription.
 */
export function getNotificationCategory(
    type: NotificationType,
    subscription: NotificationSubscription
): string {
    return `${type}/${subscription}`;
}

/**
 * Returns the category type and subscription type for a given MagicBell category slug. Categories
 * are formatted with `category/subscribers`, where `subscribers` is one of the supported subscriber
 * types.
 */
export function parseNotificationCategory(
    category: string
): [type: NotificationType, subscription: NotificationSubscription | undefined] {
    const parts = category.split('/');
    if (parts.length === 2) {
        return [parts[0] as NotificationType, parts[1] as NotificationSubscription];
    }

    return [parts[0] as NotificationType, undefined];
}
